import axios from 'axios'
import endpoint from '@src/data/endpoint.json'

export default {
  data() {
    return {
      endpoint,
      loading: false,
    }
  },

  methods: {
    op(config, isFetch = false) {
      this.loading = true
      return axios(config)
        .then((response) => {
          this.loading = false
          if (!isFetch) {
            this.displayMessage('Data has been updated successfully.')
          }
          return Promise.resolve(response.data)
        })
        .catch((error) => {
          this.loading = false

          if (error.response) {
            const { status, data } = error.response
            let { message } = data

            if (status === 401) {
              return this.$router.push({
                name: 'login',
                query: {
                  redirectFrom: this.$route.fullPath,
                },
              })
            }

            if (status === 500) {
              message = 'An error was occured. Please try again.'
            }

            this.displayMessage(message)
          }

          return Promise.reject(error)
        })
    },
    fetchData(config) {
      return this.op(config, true)
    },
    updateData(config) {
      return this.op(config)
    },
    displayMessage(message) {
      this.$store.commit('app/SET_SNACKBAR', {
        text: message,
      })
    },
  },
}
